import {Component, Input, ViewChild} from '@angular/core';
import {BaseResultComponent} from '../base-result/base-result.component';
import {SafeguardResult} from '../../../class/result/safeguard-result';
import {FamilyIncomeResult} from '../../../class/result/family-income-result';
import {PipeChartResult} from '../../../class/result/pipe-chart-result';
import {IncomeRepartitionComponent} from '../income-repartition/income-repartition.component';
import {NbWindowService} from '@nebular/theme';
import {WelfareResultService} from "../../../service/welfare-result.service";

@Component({
  selector: 'app-safeguard',
  templateUrl: './safeguard.component.html',
  styleUrls: ['./safeguard.component.css']
})
export class SafeguardComponent extends BaseResultComponent {

  @Input()
  safeguard: SafeguardResult;

  @Input()
  incomeResult: FamilyIncomeResult;

  @Input()
  lightView: boolean;

  @Input()
  pipeResult: PipeChartResult;

  @Input()
  showCoverFlags: boolean;

  @Input()
  showIncomeRepartition = true;

  @ViewChild('incomeRepartitionComponent')
  incomeRepartiton: IncomeRepartitionComponent;

  constructor(windowService: NbWindowService, private welfareService: WelfareResultService) {
    super(windowService);
  }

  ngOnInitImpl(): void {
    super.ngOnInitImpl();
    this.onResultImpl();
  }

  get isSingle() {
    return this.welfareService.isSingle();
  }

  onResultImpl() {
    if (this.incomeRepartiton) {
      this.incomeRepartiton.pipeResult = this.pipeResult;
      this.incomeRepartiton.incomeResult = this.incomeResult;
      this.incomeRepartiton.onResultImpl();
    }
  }
}
